<app-attendee-jumbotron
  class="activities-jumbotron"
  [title]="title"
  [description]="description"
  [imgMobile]="imgMobile"
  [imgDesktop]="imgDesktop"
  [variant]="variant"
  [textColor]="textColor"
  [isHp]="isHp"
>
  <ng-content></ng-content>
</app-attendee-jumbotron>
